module.exports = __webpack_public_path__ + "b04fa47337aadead62ebd01fd179aaeb.png";